// import React, { useState, useRef } from 'react';

import * as EditorTypeAll from '../tinymce';
import { Redo2, Undo2 } from 'lucide-react';

interface Props {
  editorInstance: EditorTypeAll.Editor;
}

export const Undo = ({ editorInstance }: Props) => {
  const undoAction = () => {
    document.body.click();
    editorInstance.execCommand('undo');
  };

  return (
    <>
      <div className="inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]" onClick={undoAction}>
        {/* <img width="18px" height="18px" src={undo} /> */}
        <Undo2 strokeWidth={1.5} size={18} />
      </div>
    </>
  );
};

export const Redo = ({ editorInstance }: Props) => {
  const redoAction = () => {
    document.body.click();
    editorInstance.execCommand('redo');
  };

  return (
    <>
      <div className="inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]" onClick={redoAction}>
        <Redo2 strokeWidth={1.5} size={18} />
      </div>
    </>
  );
};
